<template lang="pug">
y-chip.text-no-wrap(:label="getStatus" :color="getStatusColor")
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: 'draft'
    },
  },
  computed: {
    getStatus () {
      const status = this.status.split('_').join(' ')
      return status.charAt(0).toUpperCase() + status.slice(1)
    },
    getStatusColor () {
      switch (this.status) {
        case 'draft':
          return 'normal'
        case 'ordered':
          return 'orange'
        case 'partially_received':
          return 'green'
        case 'fully_received':
          return 'blue'
        default:
          return 'grey'
      }
    }
  },

}
</script>

<style scoped>
</style>